import { PRESCRIPTION_LAYOUTS } from 'src/consumer/constants'

/**
 * Configuration for prescription layout-specific behavior
 * Centralizes conditional logic based on layout type
 */

/**
 * Get the number of clinic detail columns for a given layout
 */
export function getClinicDetailsColumnCount(layout) {
  const columnConfig = {
    [PRESCRIPTION_LAYOUTS.threeColumnFooter]: 3,
    [PRESCRIPTION_LAYOUTS.twoColumnFooter]: 2,
    [PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter]: 2,
  }
  return columnConfig[layout] || 0
}

/**
 * Get the MD grid size for related clinic details based on layout
 */
export function getRelatedClinicDetailsMdSize(layout) {
  const sizeConfig = {
    [PRESCRIPTION_LAYOUTS.threeColumnFooter]: 4,
    [PRESCRIPTION_LAYOUTS.twoColumnFooter]: 6,
    [PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter]: 6,
  }
  return sizeConfig[layout] || 12
}

/**
 * Check if layout uses list pointers footer
 */
export function hasListPointersFooter(layout) {
  return (
    layout === PRESCRIPTION_LAYOUTS.listPointersFooter ||
    layout === PRESCRIPTION_LAYOUTS.twoDoctorHeaderWithListPointers
  )
}

/**
 * Check if layout has two doctor headers
 */
export function hasTwoDoctorHeader(layout) {
  return (
    layout === PRESCRIPTION_LAYOUTS.twoDoctorHeader ||
    layout === PRESCRIPTION_LAYOUTS.twoDoctorHeaderWithListPointers
  )
}

/**
 * Check if layout has column-based footer
 */
export function hasColumnFooter(layout) {
  return (
    layout === PRESCRIPTION_LAYOUTS.threeColumnFooter ||
    layout === PRESCRIPTION_LAYOUTS.twoColumnFooter ||
    layout === PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter
  )
}

/**
 * Check if layout has disclaimer footer
 */
export function hasDisclaimerFooter(layout) {
  return (
    layout === PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooter ||
    layout === PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooterWithDegreesInSeperateLines
  )
}

/**
 * Determines which footer fields should be shown for a layout
 */
export function getFooterFieldsConfig(layout) {
  const showColumnFooter = hasColumnFooter(layout)
  const showListPointers = hasListPointersFooter(layout)
  const showDisclaimer = hasDisclaimerFooter(layout)

  return {
    // Standard fields (hidden for column footers and list pointers)
    showStandardFields:
      !showColumnFooter && !showListPointers && layout !== PRESCRIPTION_LAYOUTS.listPointersFooter,

    // Alt fields (hidden for column footers)
    showAltFields: !showColumnFooter,

    // List pointer fields
    showListPointerFields: showListPointers,

    // Disclaimer field
    showDisclaimerField: showDisclaimer,

    // Support text always shows except for three column
    showSupportText: layout !== PRESCRIPTION_LAYOUTS.threeColumnFooter,

    // Support text alt shows for non-three-column layouts
    showSupportTextAlt: layout !== PRESCRIPTION_LAYOUTS.threeColumnFooter,

    // Subtext always shows
    showSubtext: true,
  }
}
